import { motion, useScroll, useSpring } from "framer-motion";

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.4 });

  return (
    <motion.div
      data-testid="scroll-progress"
      className="fixed inset-x-0 top-0 z-50 h-[2px] origin-left bg-[#C4A24C]"
      style={{ scaleX }}
      aria-hidden="true"
    />
  );
};
